const AD = {
  HANDLE_EXTERNAL_CHANGE: 'AD.HANDLE_EXTERNAL_CHANGE',
  HANDLE_POSITION_CHANGE: 'AD.HANDLE_POSITION_CHANGE',
  HANDLE_PAUSE_CHANGE: 'AD.HANDLE_PAUSE_CHANGE',
  HANDLE_SKIP_AD: 'AD.HANDLE_SKIP_AD',
};

export default AD;
